module.exports = __webpack_public_path__ + "static/media/Bike.668722e7.svg";